// Default List Item Text
export const TXT_DEFAULT_NO_KARYA = 'Belum ada karya'
export const TXT_DEFAULT_NO_PERANGKAT_AJAR = 'Belum ada perangkat ajar'

// Share
export const SHARE_TEXT =
  'Bapak/Ibu Guru, coba cek profil rekan pendidik berikut. Ada karya yang bisa jadi inspirasi!'

// Allowed file types
export const ALLOWED_FILE_MIMES = ['image/png', 'image/jpg', 'image/jpeg']

// Photo
export const MIN_PHOTO_HEIGHT = 80
export const MIN_PHOTO_WIDTH = 80
export const MAX_PHOTO_SIZE = 5 // 5 MB
export const UPLOAD_PHOTO_DIR_PATH = 'photo'

// Cover
export const MIN_COVER_HEIGHT = 240
export const MIN_COVER_WIDTH = 720
export const MAX_COVER_SIZE = 5 // 5 MB
export const UPLOAD_COVER_DIR_PATH = 'cover'

// Edit Info
export const SOCIAL_MEDIA_FIELDS = [
  'tiktok',
  'facebook',
  'youtube',
  'instagram',
  'twitter',
]
export const SOCIAL_MEDIA_USERNAME_CHAR_REGEX = /^((?!@).)*$/
export const SOCIAL_MEDIA_USERNAME_HTTP_REGEX = /^((?!(https?:\/\/)).)*$/

// Personal Data
export const PERSONAL_DATA_KEYS = {
  name: 'Nama lengkap',
  dateOfBirth: 'Tanggal lahir',
  placeOfBirth: 'Tempat lahir',
  npsn: 'NPSN',
  latestDegree: 'Pendidikan formal terakhir',
  personalEmail: 'Email pribadi',
  email: 'Email akun PMM',
  phoneNumber: 'Nomor HP',
}

// Bukti Karya
export const BUKTI_KARYA_CATEGORIES = {
  ARTIKEL: {
    icon: 'newspaper',
    title: 'Artikel',
  },
  BAHAN_AJAR: {
    icon: 'text_snippet',
    title: 'Bahan Ajar',
  },
  KEPEMIMPINAN_SEKOLAH: {
    icon: 'groups',
    title: 'Kepemimpinan Sekolah',
  },
  PRAKTIK_PEMBELAJARAN: {
    icon: 'book',
    title: 'Praktik Pembelajaran',
  },
  PRAKTIK_BAIK: {
    icon: 'playlist_add_check',
    title: 'Praktik Baik',
  },
  RPP: {
    icon: 'format_list_bulleted',
    title: 'RPP/Modul Ajar',
  },
  KARYA_LAINNYA: {
    icon: 'web',
    title: 'Karya Lainnya',
  },
}

// Certificates
export const CERTIFICATE_HELP_ZENDESK_LINK =
  process.env.NEXT_PUBLIC_PUSAT_INFORMASI_RUMDIK_BASE_URL +
  '/hc/id/articles/52513318049049-Sertifikat-Pelatihan-di-Halaman-Profil-Akun'

export const ERROR_STATE_TRACKER_ACTIVITY_TYPE = {
  InternalServerError: 'ERROR_SYSTEM_ERROR',
  NetworkError: 'ERROR_NO_INTERNET',
  ForbiddenError: 'ERROR_NO_ACCESS',
}
